export class AggregationFilter {

    public precision: string;
    public clusterMinCount: number;

    constructor(obj: Partial<AggregationFilter>) {
        Object.assign(this, obj);
    }

}
